import { easing } from "./scroll-snap.utils";

const opacityEasing = (
  start: number,
  end: number,
  elapsed: number,
  period: number,
) => {
  if (elapsed > period) {
    return 1;
  }
  const opacity = 0 + (end - start) * easing(elapsed / period);
  return opacity;
};

const positionEasing = (
  start: number,
  end: number,
  elapsed: number,
  period: number,
) => {
  if (elapsed > period) {
    return end;
  }
  const x = start + (end - start) * easing(elapsed / period);
  return x;
};

export const fade = (element: HTMLElement, endX: number) => {
  const startOpacity = 0;
  const period = 500;
  let startTime: number;
  return function step(timestamp: number) {
    if (typeof startTime === "undefined") {
      startTime = timestamp;
    }
    const elapsed = timestamp - startTime;
    element.style.opacity = `${opacityEasing(
      startOpacity,
      1,
      elapsed,
      period,
    )}`;
    element.scrollLeft = endX;
    if (elapsed < period) {
      requestAnimationFrame(step);
    }
  };
};

export const smoothScroll = (
  element: HTMLElement,
  endX: number,
  handleSetStartX: (scrollLeft: number) => void,
) => {
  const startX = element.scrollLeft;

  const requestAnimationFrame =
    window?.requestAnimationFrame ||
    function (fn: () => void) {
      return setTimeout(fn, 15);
    };

  const period = startX === 0 ? 1 : 300;
  let startTime: number;
  return function step(timestamp: number) {
    if (!startTime) {
      startTime = timestamp;
    }
    const elapsed = timestamp - startTime;
    // change position on x-axis if result is a number.
    const scrollTo = positionEasing(startX, endX, elapsed, period);
    element.scrollLeft = scrollTo;
    // check if we are over due;
    if (elapsed < period) {
      requestAnimationFrame(step);
    }
  };
};

export function animate({
  obj,
  startX,
  endX,
  handleSetAnimationFrame,
  handleSetStartX,
  animation = "smooth-scroll",
}: {
  obj: HTMLElement;
  endX: number;
  startX: number;
  animation?: "smooth-scroll" | "fade";
  handleSetAnimationFrame: (animationFrame: number) => void;
  handleSetStartX: (scrollLeft: number) => void;
}) {
  // get animation frame or a fallback
  const requestAnimationFrame =
    window?.requestAnimationFrame ||
    function (fn: () => void) {
      return setTimeout(fn, 15);
    };

  let step;

  if (animation === "smooth-scroll") {
    step = smoothScroll(obj, endX, handleSetStartX);
  }

  if (animation === "fade") {
    step = fade(obj, endX);
  }

  if (step) {
    handleSetAnimationFrame(requestAnimationFrame(step));
    // handleSetStartX(obj.scrollLeft);
  }
}
